import React, {useState} from 'react';
import {motion} from 'framer-motion';
import {observer} from 'mobx-react-lite';
import stepperStore from '../../../store/stepper-store';
import StepperStore from "../../../store/stepper-store";
import {useHaptic} from "../../../Hooks/useHaptic";
import Lottie from "react-lottie";
import copyAnimations from "../../Lottie/copy.json";
import UserStore from "../../../store/user-store";
import checkmark from "../../Lottie/checkmark.json";
import {createPortal} from "react-dom";


const PlatformsPopup = ({isOpen, onClose, isRu}) => {
    if (!isOpen) return null;

    const platforms = [
        {
            name: isRu ? "v2RayTun на iPhone" : "v2RayTun on iPhone",
            url: "https://apps.apple.com/en/app/v2raytun/id6476628951",
            icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                    d="M18.3573 12.7284C18.3899 16.2534 21.4499 17.4266 21.4837 17.4416C21.4578 17.5241 20.9949 19.1133 19.8717 20.7545C18.9009 22.1735 17.8931 23.5873 16.3059 23.6169C14.7462 23.6454 14.2447 22.6918 12.4614 22.6918C10.6786 22.6918 10.1216 23.5873 8.645 23.6454C7.11275 23.7035 5.94593 22.1107 4.967 20.6972C2.96675 17.8052 1.43806 12.525 3.49062 8.96078C4.51025 7.19078 6.33275 6.07009 8.31068 6.04122C9.81518 6.01253 11.2353 7.05334 12.155 7.05334C13.0741 7.05334 14.7999 5.80159 16.6141 5.98534C17.3737 6.01703 19.5056 6.29209 20.8745 8.29609C20.7644 8.36453 18.3309 9.78128 18.3573 12.7284ZM15.4261 4.07228C16.2395 3.08772 16.787 1.71671 16.6377 0.353027C15.4651 0.40009 14.0472 1.13434 13.2063 2.11853C12.4526 2.98984 11.7926 4.38484 11.9705 5.72153C13.2776 5.82278 14.6126 5.0574 15.4261 4.07228Z"
                    fill="white"/>
            </svg>
        },
        {
            name: isRu ? "v2RayTun на Android" : "v2RayTun on Android",
            url: "https://play.google.com/store/apps/details?id=com.v2raytun.android",
            icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <g clipPath="url(#clip0_17_550)">
                    <path fillRule="evenodd" clipRule="evenodd"
                          d="M15.2818 2.19368L16.3198 0.304878C16.3391 0.257889 16.3404 0.205433 16.3234 0.157549C16.3065 0.109665 16.2725 0.0697172 16.2279 0.0453507C16.1833 0.0209841 16.1313 0.0139107 16.0819 0.0254841C16.0324 0.0370575 15.9889 0.0664649 15.9598 0.108078L14.911 2.01608C13.9929 1.61214 13.0005 1.40451 11.9974 1.40648C10.9546 1.40648 9.96941 1.62368 9.0886 2.01368L8.03741 0.108078C8.0247 0.0842287 8.00738 0.0631417 7.98646 0.0460414C7.96553 0.0289411 7.94142 0.0161683 7.91552 0.00846482C7.88962 0.00076135 7.86244 -0.00171929 7.83557 0.00116696C7.80871 0.00405321 7.78268 0.0122488 7.75901 0.0252779C7.73516 0.0379842 7.71407 0.0553022 7.69697 0.0762261C7.67987 0.0971501 7.6671 0.121263 7.65939 0.147165C7.65169 0.173066 7.64921 0.20024 7.65209 0.227108C7.65498 0.253976 7.66318 0.280003 7.6762 0.303678L8.7154 2.19008C6.67541 3.23888 5.2954 5.23448 5.2966 7.52648L18.6958 7.52528C18.6958 5.23328 17.3206 3.24248 15.2818 2.19368ZM8.9482 5.10848C8.87461 5.1084 8.80176 5.09383 8.7338 5.06559C8.66583 5.03735 8.6041 4.99601 8.55212 4.94392C8.50014 4.89182 8.45892 4.83 8.43083 4.76198C8.40274 4.69396 8.38833 4.62107 8.3884 4.54748C8.38848 4.47389 8.40306 4.40103 8.43129 4.33307C8.45953 4.26511 8.50087 4.20337 8.55297 4.15139C8.60506 4.09941 8.66688 4.0582 8.7349 4.03011C8.80292 4.00202 8.87581 3.9876 8.94941 3.98768C9.09819 3.98768 9.24088 4.04678 9.34609 4.15199C9.4513 4.2572 9.51041 4.39989 9.51041 4.54868C9.51041 4.69746 9.4513 4.84016 9.34609 4.94536C9.24088 5.05057 9.09819 5.10968 8.94941 5.10968M18.6502 8.04008L18.6526 17.6545C18.6526 18.2317 18.3382 18.7309 17.875 19.0069C17.631 19.1556 17.3508 19.2345 17.065 19.2349L15.9802 19.2361V22.5169C15.98 22.7374 15.9307 22.955 15.8359 23.1541C15.741 23.3531 15.6031 23.5286 15.4319 23.6676C15.2608 23.8067 15.0609 23.9058 14.8467 23.9579C14.6324 24.0101 14.4093 24.0138 14.1934 23.9689C13.859 23.9 13.5584 23.7183 13.3421 23.4542C13.1258 23.19 13.0069 22.8595 13.0054 22.5181V19.2361H10.9954V22.5181C10.9948 22.9116 10.8379 23.2887 10.5594 23.5666C10.2808 23.8445 9.90329 24.0004 9.50981 24.0001C9.11662 23.9994 8.73966 23.8432 8.4613 23.5655C8.18293 23.2878 8.02579 22.9113 8.0242 22.5181V19.2361H6.943C6.3178 19.2361 5.7826 18.8761 5.52461 18.3529C5.41481 18.1368 5.35687 17.8981 5.3554 17.6557L5.353 8.04368L18.6502 8.04008ZM3.2878 7.76408C4.1086 7.76408 4.7758 8.42768 4.7758 9.24488V15.4489C4.7758 15.5505 4.7658 15.6501 4.7458 15.7477C4.69648 15.9855 4.58958 16.2077 4.43447 16.3946C4.27936 16.5816 4.08077 16.7276 3.8561 16.82C3.63143 16.9124 3.38753 16.9483 3.14577 16.9245C2.90402 16.9007 2.67178 16.818 2.4694 16.6837C2.26405 16.5494 2.09539 16.3661 1.97869 16.1503C1.86198 15.9345 1.80091 15.693 1.801 15.4477L1.7998 9.24488C1.7998 8.42888 2.4658 7.76408 3.2878 7.76408ZM20.7118 7.76288C21.5326 7.76288 22.1998 8.42528 22.1998 9.24368V15.4465C22.1998 16.2661 21.5338 16.9285 20.713 16.9285C19.891 16.9285 19.225 16.2661 19.225 15.4465V9.24248C19.225 8.42408 19.8898 7.76048 20.7106 7.76168M15.0478 3.99008C15.1235 3.98657 15.1991 3.99845 15.2701 4.02501C15.3411 4.05156 15.4059 4.09223 15.4607 4.14455C15.5155 4.19688 15.5592 4.25978 15.589 4.32945C15.6188 4.39911 15.6341 4.4741 15.6341 4.54988C15.6341 4.62565 15.6188 4.70064 15.589 4.77031C15.5592 4.83998 15.5155 4.90288 15.4607 4.9552C15.4059 5.00753 15.3411 5.0482 15.2701 5.07475C15.1991 5.1013 15.1235 5.11318 15.0478 5.10968C14.9721 5.11318 14.8965 5.1013 14.8255 5.07475C14.7545 5.0482 14.6897 5.00753 14.6349 4.9552C14.5801 4.90288 14.5365 4.83998 14.5067 4.77031C14.4768 4.70064 14.4615 4.62565 14.4615 4.54988C14.4615 4.4741 14.4768 4.39911 14.5067 4.32945C14.5365 4.25978 14.5801 4.19688 14.6349 4.14455C14.6897 4.09223 14.7545 4.05156 14.8255 4.02501C14.8965 3.99845 14.9721 3.98657 15.0478 3.99008Z"
                          fill="white"/>
                </g>
                <defs>
                    <clipPath id="clip0_17_550">
                        <rect width="24" height="24" fill="white"/>
                    </clipPath>
                </defs>
            </svg>
        },
        {
            name: isRu ? "v2RayTun на Windows" : "v2RayTun on Windows",
            url: "https://storage.v2raytun.com/v2RayTun_Setup.exe",
            icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path fillRule="evenodd" clipRule="evenodd"
                      d="M1.00615 11.8824L1 4.97459L9.36702 3.83441V11.8848H1.00615V11.8824ZM10.8436 3.63059L21.9139 2V11.8824H10.8436V3.63059ZM22 13.1176L21.9151 23L10.7611 21.425L10.8436 13.1176H22ZM9.36702 21.2459L1.00615 20.0958V13.1176H9.36702V21.2459Z"
                      fill="white"/>
            </svg>
        },
        {
            name: isRu ? "v2RayTun на MacBook" : "v2RayTun on MacBook",
            url: "https://apps.apple.com/en/app/v2raytun/id6476628951",
            icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                    d="M18.3573 12.7284C18.3899 16.2534 21.4499 17.4266 21.4837 17.4416C21.4578 17.5241 20.9949 19.1133 19.8717 20.7545C18.9009 22.1735 17.8931 23.5873 16.3059 23.6169C14.7462 23.6454 14.2447 22.6918 12.4614 22.6918C10.6786 22.6918 10.1216 23.5873 8.645 23.6454C7.11275 23.7035 5.94593 22.1107 4.967 20.6972C2.96675 17.8052 1.43806 12.525 3.49062 8.96078C4.51025 7.19078 6.33275 6.07009 8.31068 6.04122C9.81518 6.01253 11.2353 7.05334 12.155 7.05334C13.0741 7.05334 14.7999 5.80159 16.6141 5.98534C17.3737 6.01703 19.5056 6.29209 20.8745 8.29609C20.7644 8.36453 18.3309 9.78128 18.3573 12.7284ZM15.4261 4.07228C16.2395 3.08772 16.787 1.71671 16.6377 0.353027C15.4651 0.40009 14.0472 1.13434 13.2063 2.11853C12.4526 2.98984 11.7926 4.38484 11.9705 5.72153C13.2776 5.82278 14.6126 5.0574 15.4261 4.07228Z"
                    fill="white"/>
            </svg>
        },
        {
            name: isRu ? "v2RayTun на Android TV" : "v2RayTun on Android TV",
            url: "https://play.google.com/store/apps/details?id=com.v2raytun.android",
            icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                    d="M21 17H3V5H21M21 3H3C2.46957 3 1.96086 3.21071 1.58579 3.58579C1.21071 3.96086 1 4.46957 1 5V17C1 17.5304 1.21071 18.0391 1.58579 18.4142C1.96086 18.7893 2.46957 19 3 19H8V21H16V19H21C21.5304 19 22.0391 18.7893 22.4142 18.4142C22.7893 18.0391 23 17.5304 23 17V5C23 4.46957 22.7893 3.96086 22.4142 3.58579C22.0391 3.21071 21.5304 3 21 3Z"
                    fill="white"/>
            </svg>
        }
    ];

    return (
        createPortal(<motion.div
            initial={{opacity: 0}}
            animate={{opacity: 1}}
            exit={{opacity: 0}}
            className="platforms"
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.78)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 10000,
                fontFamily: "VK Sans Display, sans-serif",
            }}
            onClick={onClose}
        >
            <motion.div
                initial={{scale: 0.9, opacity: 0}}
                animate={{scale: 1, opacity: 1}}
                exit={{scale: 0.9, opacity: 0}}
                style={{
                    backgroundColor: '#1A1B1E',
                    padding: '24px',
                    borderRadius: '12px',
                    maxWidth: '90%',
                    width: '500px'
                }}
                onClick={e => e.stopPropagation()}
            >
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: 20
                }}>
                    <h3 style={{color: '#fff', margin: 0}}>{isRu ? "Доступные Платформы:" : "Available Platforms:"}</h3>
                    <button
                        onClick={onClose}
                        style={{
                            border: 'none',
                            color: '#fff',
                            cursor: 'pointer',
                            padding: '10px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            opacity: 0.6,
                            transition: 'opacity 0.2s',
                            marginLeft: 16,
                            right: 0,
                            borderRadius: "50%",
                            backgroundColor: "rgb(45, 47, 49)",
                        }
                        }
                        onMouseEnter={e => e.currentTarget.style.opacity = '1'}
                        onMouseLeave={e => e.currentTarget.style.opacity = '0.6'}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M15.3332 2.39224L2.39199 15.3334L0.666504 13.6079L13.6077 0.666748L15.3332 2.39224Z" fill="white"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M13.6077 15.3334L0.666504 2.39224L2.39199 0.666748L15.3332 13.6079L13.6077 15.3334Z" fill="white"></path></svg>
                    </button>
                </div>
                <div className="list" style={{
                    display: 'grid',
                    gap: '12px',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))'
                }}>
                    {platforms.map((platform, index) => (
                        <motion.div
                            key={index}
                            initial={{opacity: 0, y: 20}}
                            animate={{opacity: 1, y: 0}}
                            transition={{delay: index * 0.1}}
                        >
                            <a
                                href={platform.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                    backgroundColor: 'transparent',
                                    border: '1px solid rgba(255, 255, 255, 0.1)',
                                    borderRadius: '8px',
                                    padding: '12px',
                                    width: '100%',
                                    color: '#fff',
                                    cursor: 'pointer',
                                    transition: 'all 0.2s',
                                    zIndex: 10000000,
                                    textDecoration: 'none',
                                }}
                                onMouseEnter={e => {
                                    e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                                }}
                                onMouseLeave={e => {
                                    e.currentTarget.style.backgroundColor = 'transparent';
                                }}
                            >
                                {platform.icon}
                                <span>{platform.name}</span>
                            </a>
                        </motion.div>
                    ))}
                </div>
            </motion.div>
        </motion.div>, document.body)

    );
};

const StepItem = ({
                      number,
                      title,
                      description,
                      isActive,
                      isCompleted,
                      onClick,
                      buttonText,
                      buttonList,
                      icon,
                      customClickURL,
                      isRu
                  }
) => {
    const {hapticFeedBack} = useHaptic("success");
    const [showPlatforms, setShowPlatforms] = useState(false);

    return (
        <div
            style={{
                display: 'flex',
                position: 'relative',
                cursor: stepperStore.canSwitchToStep(number) ? 'pointer' : 'default',
                opacity: stepperStore.canSwitchToStep(number) ? 1 : 0.7
            }}
            onClick={() => stepperStore.canSwitchToStep(number) && stepperStore.setCurrentStep(number)}
        >
            <div style={{
                width: 24,
                height: 24,
                borderRadius: '50%',
                backgroundColor: isActive || isCompleted ? '#FFFFFF' : 'transparent',
                border: isActive || isCompleted ? 'none' : '1px solid rgba(255, 255, 255, 0.3)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: isActive || isCompleted ? '#000000' : '#FFFFFF',
                fontWeight: 500,
                fontSize: 14,
                zIndex: 2,
                flexShrink: 0
            }}>
                {number}
            </div>

            {/* Content */}
            <div style={{marginLeft: 12, marginBottom: 40, flex: 1}}>
                <h3 style={{
                    margin: 0,
                    fontSize: 16,
                    color: '#FFFFFF',
                    fontWeight: isActive ? 600 : 400,
                }}>
                    {title}
                </h3>
                <p style={{
                    margin: '4px 0 16px 0',
                    fontSize: 14,
                    color: 'rgba(255, 255, 255, 0.6)'
                }}>
                    {description}
                </p>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 18,
                        width: "max-content"
                    }}

                >
                    {isActive && buttonText && (
                        <motion.button
                            initial={{opacity: 0, y: 10}}
                            animate={{opacity: 1, y: 0}}
                            transition={{duration: 0.3}}
                            style={{
                                backgroundColor: '#fff',
                                color: '#000',
                                display: 'flex',
                                alignItems: 'center',
                                gap: 5,
                                border: 'none',
                                borderRadius: 8,
                                padding: '10px 16px',
                                fontSize: 14,
                                fontWeight: 500,
                                cursor: 'pointer',
                                zIndex: 10000,
                                fontFamily: 'VK Sans Display, sans-serif',
                                position: "relative"
                            }}
                            onClick={(e) => {
                                e.stopPropagation(); // Предотвращаем всплытие события
                                hapticFeedBack();
                                onClick();
                                customClickURL && window.open(customClickURL);
                            }}
                        >
                            {icon && icon}
                            <p>{buttonText}</p>
                        </motion.button>
                    )}
                    {number === 1 && <button style={{
                        backgroundColor: 'transparent',
                        color: '#fff',
                        border: 'none',
                        cursor: 'pointer',
                    }} onClick={(e) => {
                        e.stopPropagation();
                        setShowPlatforms(true);
                    }}><u>{isRu ? "Другая платформа" : "Other platform"}</u></button>}
                    {showPlatforms &&
                        <PlatformsPopup isOpen={showPlatforms} onClose={() => setShowPlatforms(false)} isRu={isRu}/>}
                </div>
                {
                    isActive && buttonList && (
                        <div style={{display: "flex", gap: 5}} onClick={e => e.stopPropagation()}>
                            {buttonList.map((button, index) => (
                                <motion.button
                                    key={index}
                                    initial={{opacity: 0, y: 10}}
                                    animate={{opacity: 1, y: 0}}
                                    transition={{duration: 0.3}}
                                    disabled={!button.isActive}
                                    style={{
                                        backgroundColor: button.isActive ? '#fff' : "gray",
                                        color: '#000',
                                        border: 'none',
                                        borderRadius: 8,
                                        padding: '10px 16px',
                                        fontSize: 14,
                                        fontWeight: 500,
                                        cursor: 'pointer',
                                        fontFamily: 'VK Sans Display, sans-serif',

                                    }}
                                    onClick={() => {
                                        onClick()
                                        hapticFeedBack();
                                    }}
                                >
                                    {button.name}
                                </motion.button>
                            ))}
                        </div>
                    )
                }
            </div>

            {/* Vertical line */}
            {number < 3 && (
                <div style={{
                    position: 'absolute',
                    left: 12,
                    top: 24,
                    width: 1,
                    height: 'calc(100% - 24px)',
                    backgroundColor: isCompleted ? '#FFFFFF' : 'rgba(255, 255, 255, 0.3)',
                    zIndex: 1
                }}/>
            )}
        </div>
    );
};

export const VerticalStepper = observer(({
                                             customSteps,
                                             onStepComplete = () => {
                                             },
                                             onAllComplete = () => {
                                             }
                                         }) => {

    const [isPlaying, setIsPlaying] = useState(false);
    const [showCopyNotification, setShowCopyNotification] = useState(false);
    const {hapticFeedBack} = useHaptic("success");
    const handleAnimationComplete = () => {
        setTimeout(() => setIsPlaying(false), 200)
    };

    const isRu = UserStore.langCode === 'ru'

    async function copyToClipboard(text) {
        try {
            await navigator.clipboard.writeText(text);
            setShowCopyNotification(true);
            setTimeout(() => setShowCopyNotification(false), 2000);
        } catch (err) {
        }
    }

    const handleStepClick = (stepNumber) => {
        if (!stepperStore.isStepCompleted(stepperStore.currentStep)) {
            stepperStore.completeStep(stepperStore.currentStep);
            onStepComplete(stepperStore.currentStep, customSteps[stepperStore.currentStep - 1]);

            if (stepperStore.completedSteps.length === customSteps.length) {
                onAllComplete();
            }
        }

        if (stepperStore.currentStep < customSteps.length) {
            stepperStore.setCurrentStep(stepperStore.currentStep + 1);
        }
    };

    return (
        <div style={{}}>
            {customSteps.map((step, index) => (
                <StepItem
                    key={index}
                    number={index + 1}
                    title={step.title}
                    description={step.description}
                    isActive={stepperStore.currentStep === index + 1}
                    isCompleted={stepperStore.isStepCompleted(index + 1)}
                    onClick={() => handleStepClick(index + 1)}
                    buttonText={step.buttonText}
                    buttonList={step?.buttonList}
                    icon={step?.icon}
                    customClickURL={step?.customClickURL}
                    isRu={isRu}
                />
            ))}
            {StepperStore.currentStep === 3 &&
                <motion.div
                    initial={{opacity: 0, y: 10}}
                    animate={{opacity: 1, y: 0}}
                    transition={{duration: 0.3}}>
                    <h3 style={{marginBottom: 10}}>Ссылка на ключи</h3>
                    <div
                        style={{
                            position: 'relative',
                            zIndex: 10000,
                            width: '100%',
                            borderRadius: 8,
                            border: '1px solid #424446',
                            backgroundColor: "#16181A",
                            display: 'flex',
                            padding: '8px',
                            alignItems: 'center',

                        }}

                        onClick={() => {
                            hapticFeedBack()
                            copyToClipboard(process.env.REACT_APP_API_URL + "/v1/sub/" + UserStore.userAccessToken)
                            setIsPlaying(true)
                        }}>

                        {showCopyNotification ? (
                            <Lottie
                                style={{
                                    height: "30px",
                                    position: "relative",
                                    zIndex: 1000,
                                }}
                                options={{
                                    loop: false,
                                    autoplay: true,
                                    animationData: checkmark
                                }}
                                eventListeners={
                                    [
                                        {
                                            eventName: "complete",
                                            callback: () => setShowCopyNotification(false),
                                        }
                                    ]
                                }
                            />
                        ) : (
                            <p style={{
                                textOverflow: 'ellipsis',
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                maxWidth: '90%',
                                fontSize: 15,
                                opacity: 0.6,
                                filter: "blur(2px)",
                            }}>
                                {process.env.REACT_APP_API_URL + "/v1/sub/" + UserStore.userAccessToken}
                            </p>
                        )}
                        <Lottie
                            options={{
                                autoplay: false,
                                loop: false,
                                animationData: copyAnimations,
                                rendererSettings: {
                                    preserveAspectRatio: 'xMidYMid slice'
                                }
                            }}
                            height={30}
                            width={30}
                            isStopped={!isPlaying}
                            isPaused={false}
                            eventListeners={[
                                {
                                    eventName: "complete",
                                    callback: handleAnimationComplete,
                                },
                            ]}
                        />
                    </div>
                </motion.div>

            }
        </div>
    );
});